import AxiosInstance from "../services/networkServices";
import {
  logAudioUploadAttempt,
  logAudioUploadError,
} from "../utils/audioUploadDebug";

export const listCategory = async (payload) => {
    const res = await AxiosInstance.post(`/category/list`, payload);
    return res.data;
}

export const createAudio = async (payload, debugContext = {}) => {
    logAudioUploadAttempt({ operation: 'create', context: debugContext, formData: payload });
    try {
        const res = await AxiosInstance.post(`/admin/audio/create`, payload);
        console.log('[Audio upload] create — success', res?.data);
        return res.data;
    } catch (error) {
        logAudioUploadError({ operation: 'create', context: debugContext, error, formData: payload });
        throw error;
    }
}

export const deleteAudio = async (payload) => {
    const res = await AxiosInstance.post(`/admin/audio/delete`, payload);
    return res.data;
}

export const listAudios = async (payload) => {
    const res = await AxiosInstance.post(`/admin/audio/list`, payload);
    return res.data;
}

export const updateAudio = async (payload, debugContext = {}) => {
    logAudioUploadAttempt({ operation: 'update', context: debugContext, formData: payload });
    try {
        const res = await AxiosInstance.post(`/admin/audio/update`, payload);
        console.log('[Audio upload] update — success', res?.data);
        return res.data;
    } catch (error) {
        logAudioUploadError({ operation: 'update', context: debugContext, error, formData: payload });
        throw error;
    }
}

export const getAudioDetail = async (payload) => {
    const res = await AxiosInstance.post(`/admin/audio/details`, payload)
    return res?.data
}
